<template>
  <a-form-item has-feedback :validate-status="status">
    <a-auto-complete
      :placeholder="placeholder"
      :dataSource="dataSource"
      :disabled="disabled"
      :defaultValue="defaultValue"
      @search="onSearch"
      @select="onSelect"
      v-if="show"
    />
  </a-form-item>
</template>

<script>
import debounce from 'lodash.debounce';

export default {
  inheritAttrs: false,
  props: ['dataSource', 'placeholder', 'disabled', 'defaultValue', 'loading'],
  data() {
    return {
      show: true,
    };
  },
  watch: {
    defaultValue() {
      // a-auto-complete doesn't re-render value on changing defaultValue, so we had to use this trick to set up the default value
      this.show = false;
      this.$nextTick(() => {
        this.show = true;
      });
    },
  },
  computed: {
    status() {
      return this.loading ? 'validating' : null;
    },
  },
  methods: {
    onSearch: debounce(function deboucedSearch(text) {
      this.search(text);
    }, 500),
    onSelect(value, option) {
      this.$emit('select', value, option);
    },
    search(searchText) {
      if (searchText.length >= 1) {
        this.$emit('search', searchText);
      } else {
        this.$emit('clear');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ant-form-item {
  margin-bottom: 0px;
  max-width: 292px;
}
</style>
